import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const OWNERS_IMG = "https://images.unsplash.com/photo-1759092912803-f2332d1f8d93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yfGVufDB8fHx8MTc3NjczNjMwNHww&ixlib=rb-4.1.0&q=85";

export const Owners = ({ onOpenAnunciar }) => {
  return (
    <section
      id="proprietarios"
      className="relative py-24 md:py-32 lg:py-40 bg-[#08122A] overflow-hidden"
      data-testid="owners-section"
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9 }}
            className="order-2 lg:order-1"
          >
            <div className="flex items-center gap-4 mb-6">
              <div className="gold-divider" />
              <span className="eyebrow">Para Proprietários</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#F5F1EA] mb-8" data-testid="owners-title">
              Tem um imóvel <span className="italic gold-text">para alugar?</span>
            </h2>
            <div className="space-y-5 text-[#A2AAC2] text-base md:text-[1rem] leading-[1.85] font-light mb-10 max-w-lg">
              <p>
                Seu imóvel pode ter muito potencial no mercado, mas para atrair o locatário
                ideal, é preciso posicionamento certo, apresentação estratégica e intermediação
                profissional.
              </p>
              <p>
                Na <span className="text-[#F5F1EA] font-normal">Parceria Certa Imobiliária</span>,
                ajudamos proprietários a apresentar seus imóveis com mais valor, conectando cada
                oportunidade ao perfil de empresa mais adequado.
              </p>
            </div>

            <button
              onClick={onOpenAnunciar}
              className="btn-gold group"
              data-testid="owners-anunciar-btn"
            >
              Quero Anunciar Meu Imóvel
              <ArrowRight size={16} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" />
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: [0.2, 0.8, 0.2, 1] }}
            className="relative order-1 lg:order-2"
          >
            <div className="aspect-[4/5] overflow-hidden">
              <img src={OWNERS_IMG} alt="Edifício corporativo" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -top-6 -left-6 w-full h-full border border-[#D4B366]/50 -z-10" />
            <div className="absolute -bottom-6 -right-6 w-24 h-24 border-b border-r border-[#D4B366]" />

            {/* Floating stat card */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="absolute -left-6 md:-left-12 bottom-12 bg-[#0B1A3A] border border-[#D4B366]/30 p-6 md:p-8 max-w-[240px] shadow-2xl"
            >
              <span className="eyebrow block mb-3">Destaque</span>
              <p className="font-display text-2xl md:text-3xl text-[#E8C97A] leading-tight">
                Valor real para o seu ativo
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
